'use client';

import { useState } from 'react';
import HTMLReactParser from 'html-react-parser';
import { FaPlus } from 'react-icons/fa6';
import { FaMinus } from 'react-icons/fa6';
import { stripHtml } from '@/app/utils/helpers';

const FaqSection = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="py-2 border-b-2" onClick={() => setIsOpen(!isOpen)}>
      <div className="p-1 flex items-center justify-between">
        <p className="me-5 font-semibold">{question}</p>
        <span>{isOpen ? <FaMinus /> : <FaPlus />}</span>
      </div>
      <div className={isOpen ? `p-1 ms-3 font-normal` : 'hidden'}>
        {HTMLReactParser(answer)}
      </div>
    </div>
  );
};

export default function Faqs({ data }) {
  // const [activeFAQ, setActiveFAQ] = useState(1); //eslint-disable-line

  const values = Object.values(data);
  const schemaObjects = [];

  for (let i = 0; i < 6; i++) {
    if (values[i] != '') {
      schemaObjects.push({
        '@type': 'Question',
        'name': values[i],
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': stripHtml(values[6 + i]),
        },
      });
    }
  }

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': schemaObjects,
  };

  return (
    <>
      <div className="my-3">
        <FaqSection
          question={data.q1}
          answer={data.a1}
          // onShow={() => (activeFAQ === 1 ? setActiveFAQ(0) : setActiveFAQ(1))}
          // isActive={activeFAQ === 1}
        />
        <FaqSection
          question={data.q2}
          answer={data.a2}
          // onShow={() => (activeFAQ === 2 ? setActiveFAQ(0) : setActiveFAQ(2))}
          // isActive={activeFAQ === 2}
        />
        <FaqSection
          question={data.q3}
          answer={data.a3}
          // onShow={() => (activeFAQ === 3 ? setActiveFAQ(0) : setActiveFAQ(3))}
          // isActive={activeFAQ === 3}
        />
        {data.q4 && (
          <FaqSection
            question={data.q4}
            answer={data.a4}
            // onShow={() => (activeFAQ === 4 ? setActiveFAQ(0) : setActiveFAQ(4))}
            // isActive={activeFAQ === 4}
          />
        )}
        {data.q5 && (
          <FaqSection
            question={data.q5}
            answer={data.a5}
            // onShow={() => (activeFAQ === 5 ? setActiveFAQ(0) : setActiveFAQ(5))}
            // isActive={activeFAQ === 5}
          />
        )}
        {data.q6 && (
          <FaqSection
            question={data.q6}
            answer={data.a6}
            // onShow={() => (activeFAQ === 6 ? setActiveFAQ(0) : setActiveFAQ(6))}
            // isActive={activeFAQ === 6}
          />
        )}
        <section>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
          />
        </section>
      </div>
    </>
  );
}
